import React from 'react';
import PropTypes from 'prop-types';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete } from '@totalsoft/rocket-ui';

const EvaluatedAttributeFilterComponent = ({ engineAttributeOptions, useAllAttributes, dispatch, isReadOnly }) => {
  const { t } = useTranslation();
  const onUseAllAttributesChanged = propertyValue => {
    if (isReadOnly) return;

    dispatch({ type: 'OnUseAllAttributesChanged', propertyValue });
  };

  const onAddNewEvaluatedAttribute = engineAttributeId => {
    const engineAttribute = engineAttributeOptions.find(x => x.engineAttributeId === engineAttributeId);

    if (engineAttribute) {
      dispatch({
        type: 'OnAddNewEvaluatedAttribute',
        engineAttribute
      });
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={3} md={2}>
        <FormControlLabel
          control={<Checkbox checked={useAllAttributes} disabled={isReadOnly} />}
          label={t('EngineScoring.UseAllAttributes')}
          onChange={event => onUseAllAttributesChanged(event.target.checked)}
        />
      </Grid>
      {!useAllAttributes ? (
        <Grid item xs={4}>
          <Autocomplete
            fullWidth
            isClearable={true}
            simpleValue
            options={engineAttributeOptions}
            onChange={event => onAddNewEvaluatedAttribute(event)}
            label={t('EngineScoring.EvaluatedAttributes.AddEngineAttribute')}
            valueKey='engineAttributeId'
            labelKey='description'
            disabled={isReadOnly}
            isSearchable={true}
          />
        </Grid>
      ) : (
        <Grid item xs={4}>
          {' '}
        </Grid>
      )}
    </Grid>
  );
};

EvaluatedAttributeFilterComponent.propTypes = {
  useAllAttributes: PropTypes.bool.isRequired,
  engineAttributeOptions: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired
};

export default EvaluatedAttributeFilterComponent;
